// we need the callback function for vidible videos avialable before the video loads or the onLoad event won't trigger.
function vidibleOnPlayerReady(player) {
    player.addEventListener(vidible.PLAYER_READY, function(e) {
       refreshVideoHeight(e.player);
    });
    if($(player.div).hasClass('vidible-b-page-video')) {
        player.addEventListener(vidible.VIDEO_END, function() {
            var published_date = $(".vdb_player").data("published");
            var videovertical = $(".vdb_player").data("videovertical");
            get_next_video(published_date, videovertical);
        });
    }
    vidibleFixLabels(player);
}
function vidibleOnPlayerReadyLoop(player) {
    //special report needs reponsive players so the fix shouldnot be used
    if(!$(player.div).hasClass('vidible-b-page-special')) {
        player.addEventListener(vidible.PLAYER_READY, function(e) {
            refreshVideoHeight(e.player);
        });
    }
    player.addEventListener(vidible.VIDEO_TIMEUPDATE, function(e) {
    	if(e.data.playheadTime + 0.2 > e.data.duration) {
    		player.seekTo(0);
    	}
    });
    vidibleFixLabels(player);
}
function refreshVideoHeight(player) {
    //UK uses a square player with fixed height and width (400x400), that setting makes the video totally unrespnsive so 100% padding bottom in styles doens't work on this case, we need to treat it differently
    var isSquare = player.jd.playerHeight === player.jd.playerWidth;
    $('.video-entry__content-main .embed-container, .top-media__video').css('padding-bottom', isSquare ? player.jd.playerHeight : '');
}
function vidibleFixLabels(player) {
    player.addEventListener(vidible.PLAYER_READY, function(e) {
        var label = $('.vdb_player').data('aria-label');
        if (label) {
            $('.vdb_player').find('iframe').attr('aria-label', label);
        }
    });
}